import { LoadingOutlined, SafetyOutlined, WarningOutlined } from "@ant-design/icons";
import { Space, Tag, Typography } from "antd";
import { FC } from "react";
import InfoRow from "./InfoRow.js";


const InfoDisplay: FC<{ data: any }> = ({ data }) => {
  return (
    <Space className="mt-4" direction="vertical" size="middle">
      <InfoRow
        label="نام و نام‌خانوادگی"
        value={`${data?.firstName || ""} ${data?.lastName || ""}`.trim() || "-"}
      />
      {data?.firstNameEnglish && data?.lastNameEnglish && (
        <InfoRow
          label="نام و نام‌خانوادگی به انگلیسی"
          value={`${data?.firstNameEnglish} ${data?.lastNameEnglish}`}
        />
      )}
      <InfoRow
        label="شماره همراه"
        value={
          <>
            <Typography.Text strong>
              {data?.phoneNumber || "-"}{" "}
            </Typography.Text>
            {
              data.phoneNumber && (
                <VerifiedBadge status={data?.isPhoneVerified ? "VERIFIED" : "REJECTED"} />
              )
            }
          </>
        }
      />
      <InfoRow
        label="کد ملی"
        value={
          <>
            <Typography.Text strong>
              {data?.nationalCode || "-"}{" "}
            </Typography.Text>
            {
              data.nationalCode && data?.isNationalCodeVerified && (
                <VerifiedBadge status="VERIFIED" />
              )
            }
          </>
        }
      />
      <InfoRow label="تاریخ تولد" value={data?.birthDate || "-"} />
      {data?.fatherName && (
        <InfoRow label="نام پدر" value={data?.fatherName} />
      )}
      {data?.address && (
        <InfoRow label="آدرس" value={data?.address} />
      )}
      {data?.postalCode && (
        <InfoRow label="کد پستی" value={data?.postalCode} />
      )}
    </Space>
  );
};

const VerifiedBadge: FC<{ status: "VERIFIED" | "PENDING" | "REJECTED" | "FAILED" }> = ({
  status,
}) => {
  if (status === "VERIFIED") {
    return (
      <Tag color="success"
        bordered={false}
        icon={<SafetyOutlined />}>
        تایید شده
      </Tag>
    );
  }

  if (["REJECTED", "NOT_VERIFIED"].includes(status)) {
    return (
      <Tag color="error"
        bordered={false}
        icon={<WarningOutlined />}>
        تایید نشده
      </Tag>
    );
  }

  if (["PENDING", "FAILED"].includes(status)) {
    return (
      <Tag color="warning" icon={<LoadingOutlined spin />}>
        در حال بررسی
      </Tag>
    );
  }

  return null;
};

export default InfoDisplay;
